import { AddIcon } from "@chakra-ui/icons";
import {
  Flex,
  Button,
  HStack,
  Input,
  Spacer,
  useToast,
} from "@chakra-ui/react";

import axios from "axios";
import MaterialTable from "material-table";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import GoBackButton from "../components/Misc/GoBackButton";
import { api } from "../config";

interface Props {}

const PapersPage: React.FC<Props> = () => {
  const history = useHistory();
  const ref = React.useRef<any>(null);
  const params: any = useParams();
  const toast = useToast();

  const [codeToDelete, setCodeToDelete] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const getPapers = async ({ start = 0, limit = 10 }) => {
    const response = await axios.get(
      `${api}/papers?_sort=id:ASC&_start=${start}&_limit=${limit}&category=${params.type.toUpperCase()}`,
      {
        withCredentials: true,
      },
    );
    return response.data;
  };

  const getTotalCount = async ({ start = 0, limit = 10 }) => {
    const response = await axios.get(
      `${api}/papers/count?_sort=id:ASC&_start=${start}&_limit=${limit}&category=${params.type.toUpperCase()}`,
      {
        withCredentials: true,
      },
    );
    return response.data;
  };

  const handleAddClick = () => {
    history.push(`/admin/quizzes-form`);
  };

  const handleDeleteByCode = async () => {
    if (
      window.confirm(
        `Are you sure you want to delete the paper with code "${codeToDelete.trim()}"? This action cannot be undone.`,
      ) === false
    ) {
      return;
    }
    if (!codeToDelete.trim()) {
      toast({
        title: "Please enter a code",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      await axios.delete(`${api}/papers/code/${codeToDelete.trim()}`, {
        withCredentials: true,
      });
      toast({
        title: "Paper deleted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setCodeToDelete("");
      if (ref.current) {
        ref.current.onQueryChange();
      }
    } catch (error: unknown) {
      let message = "Unexpected error";

      if (
        typeof error === "object" &&
        error !== null &&
        "response" in error &&
        typeof (error as any).response === "object"
      ) {
        message =
          (error as any)?.response?.data?.message ||
          (error as any)?.message ||
          message;
      } else if (error instanceof Error) {
        message = error.message;
      }

      toast({
        title: "Failed to delete paper",
        description: message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!params.type) return <div>URL Parameters Required</div>;

  return (
    <div>
      <GoBackButton />
      <Flex align="center" gap={3} m={3} flexWrap="wrap">
        <Button
          colorScheme="blue"
          onClick={handleAddClick}
          size="sm"
          leftIcon={<AddIcon />}
          textTransform="uppercase"
        >
          Add Paper
        </Button>

        <Spacer />

        <HStack spacing={2}>
          <Input
            size="sm"
            placeholder="Enter code to delete"
            value={codeToDelete}
            onChange={(e) => setCodeToDelete(e.target.value)}
            maxW="200px"
          />
          <Button
            size="sm"
            colorScheme="red"
            onClick={handleDeleteByCode}
            textTransform="uppercase"
            isLoading={loading}
          >
            Delete Paper
          </Button>
        </HStack>
      </Flex>

      <MaterialTable
        tableRef={ref}
        title={`Papers`}
        columns={[
          { title: "Code", field: "code" },
          { title: "Topic", field: "topic" },
        ]}
        localization={{
          header: {
            actions: "",
          },
        }}
        actions={[
          {
            icon: "edit",
            tooltip: "Edit Paper",
            position: "auto",
            onClick: (event, rowData: any) => {
              history.push(`/admin/quizzes-form/${rowData.id}`);
            },
          },
        ]}
        options={{
          actionsColumnIndex: 0,
          exportButton: false,
          filtering: false,
          search: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, 40],
        }}
        data={(query) =>
          new Promise((resolve, reject) => {
            Promise.all([
              getPapers({
                start: query.page * query.pageSize,
                limit: query.pageSize,
              }),
              getTotalCount({
                start: query.page * query.pageSize,
                limit: query.pageSize,
              }),
            ]).then((result) => {
              resolve({
                data: result[0],
                page: query.page,
                totalCount: result[1],
              });
            });
          })
        }
      />
    </div>
  );
};

export default PapersPage;
